import { findIndex, head, isEmpty } from 'lodash';
import _ from 'lodash';
import * as constants from './Exercise.constants';
import * as services from './Exercise.service';

import { answer, getQuestion, markQuestion } from '../../global/service';

export const storeFactory = (constants, services, answer) => {
  const state = {
    QuestionList: [],
    isRequest: false,
    Question: {},
    FirstFilterList: [],
    typeQuestionList4mycollection: [],
    mywrongCountList: [],
    PzFilterData: {},
    CourseAnalysis: {},
    AfterExerciseData: {},
    isBookLevelUp: false,
    isCourseLevelUp: false,
    bookLevelUpTo: 0,
    courseLevelUpTo: 0,
    books: [],
    BookList: [],
  };

  const mutations = {
    [constants.SET_BOOK_LEVEL_UP_TO](state, level) {
      state.bookLevelUpTo = level;
    },

    [constants.SET_COURSE_LEVEL_UP_TO](state, level) {
      state.courseLevelUpTo = level;
    },

    [constants.SET_BOOK_LEVEL_UP_STATUS](state, status) {
      state.isBookLevelUp = status;
    },

    [constants.SET_COURSE_LEVEL_UP_STATUS](state, status) {
      state.isCourseLevelUp = status;
    },

    [constants.SET_IS_REQUEST_STATUS](state, status) {
      state.isRequest = status;
    },

    [constants.GET_COURSE_ANALYSIS_SUCCESS](state, data) {
      state.CourseAnalysis = data;
    },

    [constants.GET_AFTER_EXERCISE_SUCCESS](state, data) {
      state.AfterExerciseData = data;
      if (!isEmpty(data)) {
        if (data.isCourseLevelUp) {
          state.isCourseLevelUp = true;
          state.courseLevelUpTo = data.courseLevelUpTo;
          state.books = data.bookList;
        } else if (!isEmpty(data.books.find(v => v.bookLevelUp == true && v.bookLevelUpTo == 4))) {
          state.isBookLevelUp = true;
          state.BookList = data.books.filter(v => v.bookLevelUp == true && v.bookLevelUpTo == 4);
        }
      }
    },

    [constants.GET_QUESTION_LIST_SUCCESS](state, list) {
      state.QuestionList = list;
    },

    [constants.GET_FIRST_FILTER_LIST_SUCCESS](state, list) {
      state.FirstFilterList = list;
    },

    [constants.GET_MY_FAVORITE_TYPE_QUESTION_LIST_SUCCESS](state, list) {
      if (undefined !== list && null !== list) {
        state.typeQuestionList4mycollection = list;
      }
    },

    [constants.GET_MY_WRONG_COUNT_LIST_SUCCESS](state, list) {
      if (undefined !== list && null !== list) {
        state.mywrongCountList = list;
      }
    },

    [constants.GET_PZ_FILTER_DATA_SUCCESS](state, data) {
      state.PzFilterData = data;
    },

    [constants.GET_QUESTION_SUCCESS](state, question) {
      if (isEmpty(question)) {
        state.Question = question;
      } else if (state.QuestionList && state.QuestionList.length > 0) {
        let isLatest = false;
        if (question.questionId === _.last(state.QuestionList).questionId) {
          isLatest = true;
        }
        const q = _.find(state.QuestionList, (q) => q.questionId === question.questionId);
        state.Question = {
          ...question,
          isAnswered: false,
          isSubmitted: false,
          isLatest,
          selectedOption: '', //question.questionType.indexOf('QA') !== -1 ? 'done' : '',
        };
        if (q.questionLanguage === question.questionLanguage) {
          state.Question = {
            ...state.Question,
            detail: {
              ...question.detail,
              imageQuestionHtml: q.imageQuestionHtml
                ? q.imageQuestionHtml
                : question.detail.imageQuestionHtml,
              imageOption0Html: q.imageOption0Html ? q.imageOption0Html : question.detail.imageOption0Html,
            },
          };
        }
        if (question.qType === 'xl') {
          const subQuestions = question.subQuestions;
          state.Question = {
            ...state.Question,
            isInSubQuestions: true,
            pos: 0,
            subQuestions: subQuestions.map((v, i) => ({
              ...v,
              isAnswered: false,
              isSubmitted: false,
              selectedOption: '', //v.questionType.indexOf('QA') !== -1 ? 'done' : '',
              isLatest: i === subQuestions.length - 1,
            })),
          };
          if (q.questionLanguage === question.questionLanguage && q.subQuestion) {
            state.Question = {
              ...state.Question,
              subQuestions: state.Question.subQuestions.map((v, i) => {
                if (q.subQuestion[i]) {
                  return {
                    ...v,
                    detail: {
                      ...v.detail,
                      imageQuestionHtml: q.subQuestion[i].imageQuestionHtml
                        ? q.subQuestion[i].imageQuestionHtml
                        : v.detail.imageQuestionHtml,
                      imageOption0Html: q.subQuestion[i].imageOption0Html ? q.subQuestion[i].imageOption0Html : v.detail.imageOption0Html,
                    },
                  }
                } else {
                  return v;
                }
              }),
            };
          }
        }
      }
    },

    [constants.UPDATE_QUESTION_HTML_SUCCESS](state, question) {
      if (isEmpty(question)) {
        state.Question = question;
      } else if (state.QuestionList && state.QuestionList.length > 0) {
        state.Question = {
          ...state.Question,
          detail: {
            ...state.Question.detail,
            imageExplainHtml: question.detail.imageExplainHtml,
            imageOption0Html: question.detail.imageOption0Html,
            imageOptionaHtml: question.detail.imageOptionaHtml,
            imageOptionbHtml: question.detail.imageOptionbHtml,
            imageOptioncHtml: question.detail.imageOptioncHtml,
            imageOptiondHtml: question.detail.imageOptiondHtml,
            imageOptioneHtml: question.detail.imageOptioneHtml,
            imageQuestionHtml: question.detail.imageQuestionHtml,
          },
        };
        if (question.qType === 'xl') {
          const subQuestions = question.subQuestions;
          state.Question = {
            ...state.Question,
            subQuestions: subQuestions.map((v, i) => ({
              ...state.Question.subQuestions[i],
              detail: {
                ...state.Question.subQuestions[i].detail,
                imageExplainHtml: v.detail.imageExplainHtml,
                imageOption0Html: v.detail.imageOption0Html,
                imageOptionaHtml: v.detail.imageOptionaHtml,
                imageOptionbHtml: v.detail.imageOptionbHtml,
                imageOptioncHtml: v.detail.imageOptioncHtml,
                imageOptiondHtml: v.detail.imageOptiondHtml,
                imageOptioneHtml: v.detail.imageOptioneHtml,
                imageQuestionHtml: v.detail.imageQuestionHtml,
              },
            })),
          };
        }
      }
    },

    [constants.SAVE_QUESTION_RANGY_MARK](state, payload) {
      const {
        imageQuestionHtml,
        imageOption0Html,
        largeHtml,
        isCurrentQuestionXL,
        currentQuestionId,
        currentSubQuestionIdx,
        questionLanguage,
      } = payload;
      const currentQuestionIdx = _.findIndex(state.QuestionList, (question) => question.questionId === currentQuestionId);
      const question = state.QuestionList[currentQuestionIdx];
      if (isCurrentQuestionXL && -1 !== currentQuestionIdx && -1 !== currentSubQuestionIdx) {
        if (!question.subQuestion) {
          question.subQuestion = [];
        }
        if (!question.subQuestion[currentSubQuestionIdx]) {
          question.subQuestion[currentSubQuestionIdx] = {};
        }
        const subQuestion = question.subQuestion[currentSubQuestionIdx];
        subQuestion.imageQuestionHtml = imageQuestionHtml;
        subQuestion.imageOption0Html = imageOption0Html;
        question.imageQuestionHtml = largeHtml;
      } else {
        question.imageQuestionHtml = imageQuestionHtml;
        question.imageOption0Html = imageOption0Html;
      }
      question.questionLanguage = questionLanguage;
    },

    [constants.QUESTION_SUBMITTED_SUCCESS](state) {
      if (state.Question.qType !== 'xl') {
        state.Question = { ...state.Question, isSubmitted: true };
      } else {
        const subQuestions = state.Question.subQuestions;
        const question = subQuestions[state.Question.pos];
        question.isSubmitted = true;
      }
    },

    [constants.ANSWER_SUCCESS](state, { questionStatus }) {
      const deltaCorrectCount = questionStatus === 1 ? 1 : 0;
      const deltaWrongCount = questionStatus === 1 ? 0 : 1;
      if (state.Question.qType !== 'xl') {
        state.Question = {
          ...state.Question,
          isAnswered: true,
          correctCount: state.Question.correctCount + deltaCorrectCount,
          wrongCount: state.Question.wrongCount + deltaWrongCount,
          personalCorrectCount: state.Question.personalCorrectCount + deltaCorrectCount,
          personalWrongCount: state.Question.personalWrongCount + deltaWrongCount,
        };
        const idx = findIndex(state.QuestionList, { questionId: state.Question.questionId });
        if (idx != -1) {
          state.QuestionList[idx].questionStatus = questionStatus;
        }
      } else {
        const subQuestions = state.Question.subQuestions;
        const question = subQuestions[state.Question.pos];
        question.isAnswered = true;
        question.isCorrect = questionStatus === 1 ? true : false;
        question.correctCount = question.correctCount + deltaCorrectCount;
        question.wrongCount = question.wrongCount + deltaWrongCount;
        question.personalCorrectCount = question.personalCorrectCount + deltaCorrectCount;
        question.personalWrongCount = question.personalWrongCount + deltaWrongCount;
        const nonAnsweredArr = subQuestions.filter(v => v.isAnswered === false);
        const isCorrectArr = subQuestions.filter(v => !v.isCorrect);
        if (nonAnsweredArr.length === 0) {
          state.Question = {
            ...state.Question,
            isAnswered: true,
          };
        }
        const idx = findIndex(state.QuestionList, { questionId: state.Question.questionId });
        if (idx != -1 && nonAnsweredArr.length === 0) {
          if (isCorrectArr.length === 0) {
            state.QuestionList[idx].questionStatus = 1;
          } else {
            state.QuestionList[idx].questionStatus = -1;
          }
        }
      }
    },

    [constants.MARK_QUESTION_SUCCESS](state, isMarked) {
      if (state.Question.qType !== 'xl' || !state.Question.isInSubQuestions) {
        state.Question = {
          ...state.Question,
          isMarked,
        };
      } else {
        const question = state.Question.subQuestions[state.Question.pos];
        question.isMarked = isMarked;
      }
    },

    // inProgress pos selectedOption
    [constants.SET_QUESTION](state, payload) {
      if (state.Question.qType !== 'xl') {
        if (state.Question.noDefiniteQuestion) {
          let options = state.Question.selectedOption;
          const { selectedOption } = payload;
          options.indexOf(selectedOption) !== -1
            ? (state.Question = {
              ...state.Question,
              selectedOption: options.replace(selectedOption, ''),
            })
            : (state.Question = {
              ...state.Question,
              selectedOption: `${options}${selectedOption}`
                .split('')
                .sort()
                .join(''),
            });
        } else {
          state.Question = {
            ...state.Question,
            ...payload,
          };
        }
      } else {
        const { selectedOption } = payload;
        if (selectedOption) {
          if (state.Question.subQuestions[state.Question.pos].noDefiniteQuestion) {
            let options = state.Question.subQuestions[state.Question.pos].selectedOption;
            if (options.indexOf(selectedOption) !== -1) {
              state.Question.subQuestions[state.Question.pos].selectedOption = options.replace(
                selectedOption,
                ''
              );
            } else {
              state.Question.subQuestions[
                state.Question.pos
              ].selectedOption = `${options}${selectedOption}`
                .split('')
                .sort()
                .join('');
            }
          } else {
            state.Question.subQuestions[state.Question.pos].selectedOption = selectedOption;
          }
        } else {
          state.Question = {
            ...state.Question,
            ...payload,
          };
        }
      }
    },

    [constants.REMOVE_WRONG_LIST_SUCCESS](state) {
      const idx = findIndex(state.QuestionList, { questionId: state.Question.questionId });
      const arr = [...state.QuestionList];
      arr.splice(idx, 1);
      state.QuestionList = [...arr];
      if (state.QuestionList.length === 0) {
        state.Question = {};
      }
    },

    [constants.NOTE_SAVED_SUCCESS](state, payload) {
      if (state.Question.qType !== 'xl') {
        state.Question.haveNote = payload.flag;
        const idx = findIndex(state.QuestionList, { questionId: payload.Question.questionId });
        state.QuestionList[idx].haveNote = payload.flag;
      } else {
        state.Question.subQuestions[state.Question.pos].haveNote = payload.flag;
        const haveNote = state.Question.subQuestions.filter(v => v.haveNote);
        const idx = findIndex(state.QuestionList, { questionId: payload.Question.questionId });
        if (haveNote.length) {
          state.QuestionList[idx].haveNote = true;
        } else {
          state.QuestionList[idx].haveNote = false;
        }
      }
    },
  };

  const actions = {
    noteSaved({ commit }, payload) {
      commit(constants.NOTE_SAVED_SUCCESS, payload);
    },

    async getCourseAnalysis({ commit }, payload) {
      commit(constants.SET_IS_REQUEST_STATUS, true);
      const res = await services.getCourseAnalysis(payload);
      commit(constants.GET_COURSE_ANALYSIS_SUCCESS, res.data.data);
      commit(constants.SET_IS_REQUEST_STATUS, false);
    },

    async getFirstFilterList({ commit }, payload) {
      let res = {};
      let typeQuestionList4mycollection = null;
      let mywrongCountList = null;
      if (payload.exerciseType === 2) {
        res = await services.getCollectionList(payload.courseId);
        typeQuestionList4mycollection = res.data.data.typeQuestionList4mycollection;
        res.data.data = res.data.data.mycollectionList;
      } else if (payload.exerciseType === 3) {
        res = await services.getWrongList(payload.courseId);
        mywrongCountList = res.data.data.mywrongCountList;
        res.data.data = res.data.data.mywrongQuestionTree;
      } else if (payload.exerciseType === 5) {
        res = await services.getBookTreeList(payload.courseId);
      } else if (payload.exerciseType === 6) {
        res = await services.getTypeList(payload.courseId);
      }
      commit(constants.GET_FIRST_FILTER_LIST_SUCCESS, res.data.data);
      if (payload.exerciseType === 2) {
        commit(constants.GET_MY_FAVORITE_TYPE_QUESTION_LIST_SUCCESS, typeQuestionList4mycollection);
      }
      if (payload.exerciseType === 3) {
        commit(constants.GET_MY_WRONG_COUNT_LIST_SUCCESS, mywrongCountList);
      }
    },

    async _getPzFilterData({ commit }, srvcPayload) {
      const { services, payload } = srvcPayload;
      const res = await services.getPzFilterData(payload);
      commit(constants.GET_PZ_FILTER_DATA_SUCCESS, res.data.data);
    },

    async getPzFilterData({ dispatch }, payload) {
      const srvcPayload = {
        services: {
          getPzFilterData: services.getPzFilterData,
        },
        payload,
      };
      await dispatch('_getPzFilterData', srvcPayload);
    },

    async getPzFilterDataType({ dispatch }, payload) {
      const srvcPayload = {
        services: {
          getPzFilterData: services.getPzFilterDataType,
        },
        payload,
      };
      await dispatch('_getPzFilterData', srvcPayload);
    },

    async _getQuestionList({ commit, rootGetters }, srvcPayload) {
      const { services, payload } = srvcPayload;
      const res = await services.getQuestionList(payload);
      const question = head(res.data.data);
      commit(constants.GET_QUESTION_LIST_SUCCESS, res.data.data);
      if (question) {
        const questionRes = await getQuestion(payload.courseId, question.questionId);
        commit(constants.GET_QUESTION_SUCCESS, {
          ...questionRes.data.data,
          questionLanguage: rootGetters.userInfo.profile.questionLanguage,
        });
      } else {
        commit(constants.GET_QUESTION_SUCCESS, {});
      }
    },

    async getQuestionList({ dispatch }, payload) {
      const srvcPayload = {
        services: {
          getQuestionList: services.getQuestionList,
        },
        payload,
      };
      await dispatch('_getQuestionList', srvcPayload);
    },

    async getQuestionListType({ dispatch }, payload) {
      const srvcPayload = {
        services: {
          getQuestionList: services.getQuestionListType,
        },
        payload,
      };
      await dispatch('_getQuestionList', srvcPayload);
    },

    async answer({ commit, state }, payload) {
      let param = {};
      if (state.Question.qType !== 'xl') {
        if (state.Question.questionType.indexOf('OP') !== -1) {
          param = {
            ...payload,
            questionId: state.Question.questionId,
            questionStatus: state.Question.answer === state.Question.selectedOption ? 1 : -1,
            studentAnswer: state.Question.selectedOption,
          };
        } else if (state.Question.questionType.indexOf('QA') !== -1) {
          param = {
            ...payload,
            questionId: state.Question.questionId,
            questionStatus: 1,
            //studentAnswer: 'done',
          };
        }
      } else {
        const question = state.Question.subQuestions[state.Question.pos];
        if (question.questionType.indexOf('OP') !== -1) {
          param = {
            ...payload,
            questionId: question.questionId,
            questionStatus: question.answer === question.selectedOption ? 1 : -1,
            studentAnswer: question.selectedOption,
          };
        } else if (question.questionType.indexOf('QA') !== -1) {
          param = {
            ...payload,
            questionId: question.questionId,
            questionStatus: 1,
            //studentAnswer: 'done',
          };
        }
      }
      commit(constants.ANSWER_SUCCESS, param);
      await answer(param);
      commit(constants.QUESTION_SUBMITTED_SUCCESS);
    },

    async getQuestion({ commit, rootGetters }, payload) {
      const questionRes = await getQuestion(payload.courseId, payload.questionId);
      commit(constants.GET_QUESTION_SUCCESS, {
        ...questionRes.data.data,
        questionLanguage: rootGetters.userInfo.profile.questionLanguage,
      });
    },

    async updateQuestionHtml({ commit }, payload) {
      const questionRes = await getQuestion(payload.courseId, payload.questionId);
      commit(constants.UPDATE_QUESTION_HTML_SUCCESS, questionRes.data.data);
    },

    async markQuestion({ commit }, { courseId }) {
      let param = {};
      if (state.Question.qType !== 'xl' || !state.Question.isInSubQuestions) {
        param = {
          markStatus: !state.Question.isMarked,
          isMark: state.Question.isMarked ? 0 : 1,
          questionId: state.Question.questionId,
          _type: 0,
          courseId,
        };
      } else {
        const question = state.Question.subQuestions[state.Question.pos];
        param = {
          markStatus: !question.isMarked,
          isMark: question.isMarked ? 0 : 1,
          questionId: question.questionId,
          _type: 0,
          courseId,
        };
      }
      const res = await markQuestion(param);
      if (res.data.status == 200) {
        commit(constants.MARK_QUESTION_SUCCESS, param.markStatus);
      }
    },

    async getAfterExerciseData({ commit }, payload) {
      const res = await services.getAfterExercise(payload);
      commit(constants.GET_AFTER_EXERCISE_SUCCESS, res.data.data);
    },

    async removeWrongList({ commit }, payload) {
      const res = await services.removeWrongList(payload);
      if (res.data.status == 200) {
        commit(constants.REMOVE_WRONG_LIST_SUCCESS);
      }
    },
  };

  const getters = {
    QuestionList: state => state.QuestionList,
    isRequest: state => state.isRequest,
    Question: state => state.Question,
    FirstFilterList: state => state.FirstFilterList,
    typeQuestionList4mycollection: state => state.typeQuestionList4mycollection,
    mywrongCountList: state => state.mywrongCountList,
    CourseAnalysis: state => state.CourseAnalysis,
    PzFilterData: state => state.PzFilterData,
    AfterExerciseData: state => state.AfterExerciseData,
    isBookLevelUp: state => state.isBookLevelUp,
    isCourseLevelUp: state => state.isCourseLevelUp,
    bookLevelUpTo: state => state.bookLevelUpTo,
    courseLevelUpTo: state => state.courseLevelUpTo,
    books: state => state.books,
    BookList: state => state.BookList,
  };

  return {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
};

export default storeFactory(constants, services, answer);
